// extracted by mini-css-extract-plugin
export default {"profile":"styles_profile__XPCYE","page":"styles_page__xyPL5","backBtn":"styles_backBtn__StoGn","header":"styles_header__ZbPHV","content":"styles_content__b8x2z"};